module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FMH"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph"
    }
  }, [_vm._v("Epigraphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/maps"
    }
  }, [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chronology"
    }
  }, [_vm._v("Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/principalcharacters"
    }
  }, [_vm._v("Principal Characters")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/anoteonspelling"
    }
  }, [_vm._v("A Note on Spelling")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/authorsnote"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-Sans"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    staticClass: "ePub-Sans"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("Part I: “They are here for their lives”")])])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("July 1936: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("July 1936: London/Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_vm._v("July 1936: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4"
    }
  }, [_vm._v("July 1936: Brno")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5"
    }
  }, [_vm._v("July 1936: Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 1936: Paris/Barcelona/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1936: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1936: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1936: Córdoba Front")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1936: Toledo/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1936: L Bar T Ranch, Wyoming")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 1936: Madrid/Cartagena/Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1936: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1936: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1936: Paris/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1936: Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1936: Naples")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1936: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1936: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1936: Valencia")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1936: Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT-1"
  }, [_c('span', {
    staticClass: "ePub-Sans"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: “You never hear the one that hits you”")])])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1937: Valencia")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1937: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February 1937: Málaga Front")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February–March 1937: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1937: Paris/Pyrenees")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1937: Madrid/Valencia/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1937: Barcelona/Valencia/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 1937: Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Bilbao")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1937: Valencia")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1937: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1937: Segovia Front/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1937: Córdoba Front")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1937: New York/Washington/Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1937: Valencia/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1937: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1937: Valencia/Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1937: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 1937: Madrid/Valencia")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 1937: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1937: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1937: Aragon/Valencia/Teruel Front")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1937: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October–November 1937: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Playa de San Juan")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: The North Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Teruel")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Teruel")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1937: Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT-1"
  }, [_c('span', {
    staticClass: "ePub-Sans"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: “La Despedida”")])])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1938: Teruel")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January–February 1938: Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January–February 1938: Post Agency lecture circuit, United States")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January–February 1938: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1938: The North Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1938: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 1938: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1938: Madrid")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1938: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June–July 1938: Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June–July 1938: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1938: Hankow")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1938: Prague")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1938: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 1938: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 1938: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 1938: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 1938: Moscow")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1939: New York")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1939: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1939: Barcelona")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February–March 1939: Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "CTT-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February–March 1939: Key West/Havana")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    staticClass: "ePub-Sans"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Glossary of Terms and Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/illustration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Amanda Vaill")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/anoteabouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0